<template>
<div class="top">
    <div class="mainWidth" style="white-space:pre;">{{ time }}</div>
</div>
</template>

<script>
import moment from 'moment';
moment.updateLocale('en', { //全局 ---dddd
    weekdays: [
        "星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"
    ]
});
export default {
    data() {
        return {
            timer: null,
            time: ''
        }
    },
    created() {
        this.setTime()
        this.timer = setInterval(this.setTime, 1000);
    },
    methods: {
        setTime() {
            this.time = moment().format('YYYY年M月D日   dddd   HH:mm')
        }
    },
    beforeDestroy() {
        if (this.timer) {
            clearInterval(this.timer) //销毁
        };
    },
}
</script>

<style lang="scss" scoped>
.top {
    height: 34px;
    background: rgba(86, 150, 255, 0.80);
    backdrop-filter: blur(2px);
    position: absolute;
    top: 0;
    left: 0;
    right: 0;

    .mainWidth {
        line-height: 34px;
        font-size: 12px;
        color: #f8fbff;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/TheTop.vue